import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);

enum OfferExpiryType {
  ByExpiryDate = 1,
  ByPeriod = 2
}

enum OfferPeriodType {
  Day = "day",
  Month = "month",
  Year = "year"
}

const PeriodOptions = [
  {
    period_type: OfferPeriodType.Day,
    period: 3,
  },
  {
    period_type: OfferPeriodType.Day,
    period: 7,
  },
  {
    period_type: OfferPeriodType.Month,
    period: 1,
  },
  {
    period_type: OfferPeriodType.Month,
    period: 3,
  },
  {
    period_type: OfferPeriodType.Month,
    period: 6,
  },
  {
    period_type: OfferPeriodType.Year,
    period: 1,
  },
]
  .reduce(
    (prev, item) => {
      const key = `${item.period_type}_${item.period}`;

      prev[key] = {
        ...item,
        label: dayjs
          .duration({
            [item.period_type]: item.period,
          })
          .humanize(),
        key,
      }
      return prev;
    }, {} as Record<string, {
      period_type: OfferPeriodType;
      period: number;
      label: string;
      key: string;
    }>,
  );


export {
  PeriodOptions,
  OfferExpiryType,
  OfferPeriodType,
}

